__turbopack_context__.v({
  "content": "helpCenterListItem-module-scss-module__PryYcW__content",
  "description": "helpCenterListItem-module-scss-module__PryYcW__description",
  "icon": "helpCenterListItem-module-scss-module__PryYcW__icon",
  "item": "helpCenterListItem-module-scss-module__PryYcW__item",
  "itemAlign": "helpCenterListItem-module-scss-module__PryYcW__itemAlign",
  "itemLink": "helpCenterListItem-module-scss-module__PryYcW__itemLink",
  "itemPosition": "helpCenterListItem-module-scss-module__PryYcW__itemPosition",
  "subAlignment": "helpCenterListItem-module-scss-module__PryYcW__subAlignment",
  "subProduct": "helpCenterListItem-module-scss-module__PryYcW__subProduct",
  "subProductPosition": "helpCenterListItem-module-scss-module__PryYcW__subProductPosition",
  "title": "helpCenterListItem-module-scss-module__PryYcW__title",
  "titleBox": "helpCenterListItem-module-scss-module__PryYcW__titleBox",
});
